<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-06-06 08:48:52
 * @LastEditTime : 2024-06-12 11:32:00
 * @LastEditors  : yangxr
 * @Description  : 翻料处理
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\turningMaterials.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block; margin-bottom: 10px">
                  <span style="margin-right: 12px">订单号</span>
                  <el-input v-model="tableParam.orderNo" style="width: 240px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">车牌号</span>
                  <el-input v-model="tableParam.carNo" style="width: 240px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select v-model="tableParam.stationId" style="width: 150px" filterable>
                    <el-option v-for="item in pointIdListArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">浇筑日期</span>
                  <el-date-picker v-model="tableParam.pourTime" type="date" unlink-panels value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">浇筑部位</span>
                  <el-input v-model="tableParam.structuralParts" style="width: 240px" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">产品名</span>
                  <el-input v-model="tableParam.productName" style="width: 240px" clearable />
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), queryHandlePage()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button size="small" class="botton_five" @click="handleTurning()">翻料处理</el-button>
              </div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :height="screenHeight - 420" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '翻料类型'">
                        <span v-if="scope.row.turnoverType == 0">余料翻料</span>
                        <span v-if="scope.row.turnoverType == 1">其他翻料</span>
                      </span>
                      <span v-else-if="item.label == '翻入车辆来源'">
                        <span v-if="scope.row.carType == 0">余料车辆</span>
                        <span v-if="scope.row.carType == 1">排队车辆</span>
                      </span>
                      <span v-else-if="item.label == '翻料余料量'">
                        <span>{{ Number(scope.row.beforeCount * 1 - scope.row.outCount * 1).toFixed(2) }}</span>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button size="mini" class="bottom_two" style="margin-left: 10px" @click="deleteWeight(scope.row.id)"> 删除 </el-button>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="queryHandlePage()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="queryHandlePage">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 翻料处理 -->
    <TurningDisposeDialog :visible.sync="turningDisposeVisible" :config="turningDisposeConfig" @updated="queryHandlePage" />
  </div>
</template>
  
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryHandlePage } from "@/api/smart/schedul/j.js";
import TurningDisposeDialog from "@/views/platform/ICPS/smart/schedul/components/TurningDisposeDialog";
import { getUserAutList } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
// import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    TurningDisposeDialog,
  },
  mixins: [mixin],
  data() {
    return {
      table: [
        { label: "翻出站点", prop: "stationName", status: true, width: "auto" },
        { label: "翻料类型", prop: "turnoverType", status: true, width: "auto" },
        { label: "翻出量", prop: "outCount", status: true, width: "auto" },
        { label: "翻出物流号", prop: "beforeLogisticsCode", status: true, width: "200" },
        { label: "订单编号", prop: "orderNo", status: true, width: "220" },
        { label: "工程名称", prop: "engineeringName", status: true, width: "200" },
        { label: "浇筑部位", prop: "structuralParts", status: true, width: "150" },
        { label: "产品名", prop: "productName", status: true, width: "auto" },
        { label: "翻出车牌号", prop: "beforeCarNo", status: true, width: "auto" },
        { label: "翻入车辆来源", prop: "carType", status: true, width: "auto" },
        { label: "翻入车牌号", prop: "carNo", status: true, width: "auto" },
        // { label: "翻入站点", prop: "productionSite", status: true, width: "auto" },
        { label: "翻入物流号", prop: "logisticsCode", status: true, width: "auto" },
        { label: "翻入前余料量", prop: "beforeCount", status: true, width: "auto" },
        // { label: "翻料余料量", prop: "", status: true, width: "auto" },

        // { label: "翻出站点", prop: "logisticsCode", status: true, width: "220" },
        // { label: "车牌号", prop: "carNo", status: true, width: "auto" },
        // { label: "站点", prop: "productionSite", status: true, width: "auto" },
      ],
      tableData: [],
      startTimDateEndTimDate: [new Date().Format("yyyy-MM-dd 00:00:00"), new Date().Format("yyyy-MM-dd 23:59:59")],
      turningDisposeVisible: false,
      turningDisposeConfig: {},
      pagesType: 0,
      pointIdListArr: "",
      UserInfo: "",
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.pointIdListArr = await getUserAutList(true);
    this.init();
    this.queryHandlePage();
  },
  methods: {
    queryHandlePage() {
      queryHandlePage(this.tableParam).then(res => {
        if (res.code == 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });
    },
    // 翻料处理
    handleTurning() {
      this.turningDisposeConfig = {};
      this.turningDisposeVisible = true;
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.queryHandlePage();
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = { ...this.tableParam, stationId: "", orderNo: "", carNo: "", pourTime: "", structuralParts: "", productName: "" };
      this.tableParam.pourTime = new Date().Format("yyyy-MM-dd 00:00:00");
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.pointIdListArr[0].id;
      }
      this.queryHandlePage();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
  